import React from 'react';
import { Box } from '@mui/material';
import ValEdSvg from '/assets/ValEd.svg';

const ValEdIcon = ({ size = 52, sx = {}, ...props }) => (
  <Box
    component="img"
    src={ValEdSvg}
    alt="ValEd"
    loading="lazy"
    sx={{
      width: size,
      height: size,
      objectFit: 'contain',
      display: 'inline-flex',
      filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.15))',
      ...sx,
    }}
    {...props}
  />
);

export default ValEdIcon;
